import { PoweredBy } from './PoweredBySymbol';

export default PoweredBy;